import Backbone from 'backbone';

import Application from 'app/Application';
import GlobalEvents from 'app/GlobalEvents';
import Navigation from 'app/Navigation';
import Helpers from 'app/src/views/handlebars/Helpers';
import { hasCapitalRights } from 'pages/views/payments/lightspeed-capital/utils/hasCapitalRights';
import { InitTrackingIdentify } from 'root/apps/tracking/InitTrackingIdentify';

// @TODO Rename this file to Payments.js

// application bootstrap
const client = new Application();

// @ts-expect-error ts-migrate(2339) FIXME: Property 'on' does not exist on type 'Application'... Remove this comment to see the full error message
client.on('start', () => {
  if (client.enabled) {
    const hasRolesModule = window.lsCloud.Modules.hasModule('reports.capital.roles');
    const hasTrackFinancialAdminAloneOnStartModule = window.lsCloud.Modules.hasModule(
      'reports.capital.track_financial_admin_alone_on_start'
    );

    Helpers.register();
    client.loadDefaultControllers();
    Backbone.history.start({ pushState: true });

    // Initializing the script and sending information to segment and heap
    if (hasRolesModule && (!hasTrackFinancialAdminAloneOnStartModule || hasCapitalRights())) {
      InitTrackingIdentify().catch(() => {});
    }
  }
});

/**
 * A check to see if the requested url is one in the client namespace.
 * By seeing if the URL starts with the string "client".
 * This is used by router.js so that it bypasses the Legacy history manipulation.
 *
 * @param {string} url
 * @returns {boolean}
 */
function isClientUrl(url: TSFixMe) {
  return url.indexOf('?') >= 0 ? url.split('?')[1].startsWith('client') : false;
}

/*
For now, this module just exports classes that need to be referenced by legacy code.
As we re-factor more of the client this will become the main entry point to our app.
*/
const App = {
  client,
  globalEvents: GlobalEvents.Events,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'Wreqr' does not exist on type 'typeof Ba... Remove this comment to see the full error message
  channel: Backbone.Wreqr.radio.channel('global'),
  navigateToClientUrl: Navigation.navigateToClientUrl,
  navigateToRegisterUrl: Navigation.navigateToRegisterUrl,
  currentUrl: Navigation.currentURL,
  isClientUrl,
};

// This is required for doing external calls to the App object
// @ts-expect-error ts-migrate(2322) FIXME: Type '{ client: Application; globalEvents: { regis... Remove this comment to see the full error message
window.App = App;
